import React from 'react'
import { getConfig, postConfig } from '../../../helpers/restHelpers'
import Loader from '../../loaders'
import { strings } from '../../../localization/strings'
import routes from '../../router/routes'
import { getPlaftormId } from '../../../helpers/dbHelpers'
import { platforms } from '../../../server/shared'
import { Button } from '@material-ui/core'

import GeneralConfig from './generalConfig'
import InsuranceConfig from './insuranceConfig'
import WooCommerceConfig from './wooCommerceConfig'
import ApiCredentialsConfig from './apiCredentialsConfig'
import TemplateConfig from './templateConfig'
import LockerConfig from './lockerConfig'

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        margin: 'auto',
        padding: 10,
        maxWidth: 600,
        minWidth: 300,
        opacity: 0.87,
        fontFamily: 'neutra',
        fontSize: '1.1428571428571428rem',
    },
    button: {
        margin: 'auto',
        marginTop: 30,
        marginBottom: 20,
    },
}

class Component extends React.Component {
    state = { loader: true, config: {}, wasEdited: false }

    componentDidMount() {
        this.setState({ platformId: getPlaftormId() })
        this.getConfig()
    }

    getConfig = () => {
        this.setState({ loader: true })
        getConfig()
            .then((x) => this.setState({ config: x }))
            .catch((x) =>
                window.showDialog(x, () =>
                    this.props.history.push(routes.orders.path)
                )
            )
            .finally(() => this.setState({ loader: false }))
    }

    handleConfirm = () => {
        this.setState({ loader: true })
        postConfig(this.state.config)
            .then(() =>
                window.showDialog(
                    {
                        title: strings.saveSuccessTitle,
                        message: strings.saveSuccessDialog,
                    },
                    () => this.props.history.push(routes.orders.path)
                )
            )
            .catch(() =>
                window.showDialog({
                    title: strings.saveErrorTitle,
                    message: strings.saveErrorDialog,
                })
            )
            .finally(() => this.setState({ loader: false }))
    }

    handleEdit = (newState) => {
        this.setState({ ...this.state, ...newState })
    }

    render() {
        const { config, wasEdited } = this.state
        const { handleEdit } = this

        if (this.state.loader) return <Loader />
        return (
            <div style={styles.container}>
                <GeneralConfig config={config} handleEdit={handleEdit} />
                {config.maximumInsurableValue &&
                    config.maximumInsurableValue > 0 ? (
                    <InsuranceConfig config={config} handleEdit={handleEdit} />
                ) : null}

                {this.state.platformId === platforms.billowShop ||
                    this.state.platformId === platforms.justPudo ? (
                    <ApiCredentialsConfig
                        config={config}
                        handleEdit={handleEdit}
                    />
                ) : null}

                {this.state.platformId === platforms.wooCommerce ? (
                    <WooCommerceConfig
                        config={config}
                        handleEdit={handleEdit}
                    />
                ) : null}

                {!config.canEditNotificationTemplate ? null : (
                    <TemplateConfig config={config} handleEdit={handleEdit} />
                )}

                {!config.lockerSecurityCodeTitleEditable ? null : (
                    <LockerConfig config={config} handleEdit={handleEdit} />
                )}

                <Button
                    style={styles.button}
                    label={strings.configSaveButton}
                    variant="contained"
                    color="primary"
                    onClick={this.handleConfirm}
                    disabled={!wasEdited}
                >
                    {strings.configSaveButton}
                </Button>
            </div>
        )
    }
}

export default Component
